import { api } from '#/Api.js'

const state = {
  api_version: '',
  devices: [],
  google_login_client_id: '',
  google_login_hosted_domain: '',
  google_login_scope: 'email',
  modes: [],
  partners: [],
  revenue_partners: [],
  available_sources: [],
  available_related_keywords_providers: [],
  available_share_processor_providers: [],
}

const getters = {
  api_version: state => state.api_version,
  devices: state => state.devices,
  google_login_client_id: state => state.google_login_client_id,
  google_login_hosted_domain: state => state.google_login_hosted_domain,
  google_login_scope: state => state.google_login_scope,
  modes: state => state.modes,
  partners: state => state.partners,
  revenue_partners: state => state.revenue_partners,
  available_sources: state => state.available_sources,
  available_related_keywords_providers: state => state.available_related_keywords_providers,
  available_share_processor_providers: state => state.available_share_processor_providers,
}

const actions = {
  load(context) {
    return new Promise((resolve, reject) => {
      //axios.get(api.path('config'))
      api.get('config')
        .then(response => {
          //console.log(response.data)
          context.commit('SET_CONFIG', response.data)
          resolve(response)
        })
        .catch(error => {
          console.log(error)
          reject(error)
        })
    })
  },
}

const mutations = {
  SET_CONFIG(state, config) {
    state.api_version = config.versions.api.app
    state.google_login_client_id = config.google_login.client_id
    state.google_login_hosted_domain = config.google_login.hosted_domain
    state.modes = config.modes
    state.partners = config.partners
    state.revenue_partners = config.revenue_partners
    state.available_sources = config.available_sources
    state.available_related_keywords_providers = config.available_related_keywords_providers
    state.available_share_processor_providers = config.available_share_processor_providers
  }
}

export default {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
}
